import { ITableColumn, SuperColumn } from '@devinforius/super-compos-17';
import { Global_Class } from 'src/app/shared/models/global';

export function getColumnsPoint(): ITableColumn[] {
  return [
    {
      field: 'id',
      header: 'id',
    },
    {
      field: 'objetSynthese',
      header: 'Titre',
    },
    {
      field: 'seanceLink.description',
      header: 'Séance',
    },
  ];
}

export function getColumnsMeeting(globalElements: Global_Class): ITableColumn[] {
  return [
    {
      field: 'description',
      header: 'Nom',
    },
    {
      field: 'typeSeanceId',
      header: 'Type',
      format: (value) => {
        if (globalElements?.types_seances_LV) {
          const type = globalElements?.types_seances_LV.find((x) => x.value === value);
          if (type) {
            return type.label;
          }
        }
      },
    },
    {
      field: 'pointsInclusCount',
      header: 'Points',
      format: (value) => {
        if (value <= 0) {
          return 0;
        } else {
          return value;
        }
      },
    },
  ];
}
